import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

import errorBoundary from '@ifeng-fe/errorBoundary';
import Slides from '@ifeng-fe/ui_pc_slides';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';
import { formatImage } from '@ifeng-fe/container_channel/common/client/utils/formatImg';
// 新闻图片页
class NewsImgsTabs extends React.PureComponent {
    state = {
        tabs: this.props.content,
        currentIndex: 0,
    };
    static propTypes = {
        content: PropTypes.array,
        onChange: PropTypes.func,
    };

    handleHover = e => {
        const currentIndex = Number(e.currentTarget.attributes['index'].value);

        this.setState({
            currentIndex,
        });
        this.props.onChange(currentIndex);
    };

    /**
     * 渲染组件
     */
    render() {
        const { tabs, currentIndex } = this.state;

        // console.log('TopSlide=',this.props)
        return (
            <div className={styles.newsImgsTabs}>
                <div className={styles.tabsWrapper}>
                    {tabs.map((item, index) => {
                        return (
                            <div
                                onMouseOver={this.handleHover}
                                className={`${styles.tabItem} ${currentIndex === index ? styles.hover : ''}`}
                                key={index}
                                index={index}>
                                <a href={item.url} title={'点击查看更多'} target="_blank">
                                    {item.title}
                                </a>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}
export default errorBoundary(NewsImgsTabs);
